import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import { SignInComponent } from 'src/app/Product/sign-in/sign-in.component';
import { LoginService } from 'src/app/_services/login.service';
import { PaymentService } from 'src/app/_services/payment.service';

@Component({
  selector: 'app-vendor-header',
  templateUrl: './vendor-header.component.html',
  styleUrls: ['./vendor-header.component.css']
})
export class VendorHeaderComponent implements OnInit {

  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();

  screenWidth = 0;
  collapsed = false;  
  firstName :any;
  lastName:any;
  constructor(
    public authService: AuthService,
    public signin : SignInComponent,
    public loginService : LoginService,
    public paymentService : PaymentService
  ) { }

  ngOnInit(): void {
    this.screenWidth = window.innerHeight;
    const token = this.authService.getToken();
    this.loginService.details(token).subscribe((response)=>
    {
       this.firstName = response['firstName'];
       this.lastName = response['lastName']
    })

  }

  toggleSidebar() {
    this.toggleSidebarForMe.emit();
  }

  clear()
  {
    this.authService.clear();
    this.paymentService.clearCache();
  }

}
